import React from 'react'
import { ReactComponent as TickCheckboxIcon } from '@svgs/keyline/tick.svg'
import styles from './styles.module.scss'

export type CheckboxProps = {
  isChecked: boolean
  label: string
  value: string
  id: string
}

type CheckboxOnChange = {
  onChange?: (args: CheckboxProps) => void
}

type CheckboxGroupInputProps = CheckboxProps & CheckboxOnChange

const CheckboxGroupInput = ({
  isChecked,
  label,
  value,
  id,
  onChange,
  ...props
}: CheckboxGroupInputProps) => {
  const toggled = () => {
    if (onChange) {
      onChange({
        isChecked: !isChecked,
        label,
        value,
        id
      })
    }
  }
  return (
    <label className={styles.checkbox} htmlFor={id} {...props}>
      <input
        className={styles.checkbox__input}
        type="checkbox"
        name={id}
        id={id}
        value={value}
        onChange={toggled}
        checked={isChecked}
      />
      <p className={styles.checkbox__labelText}>{label}</p>
      <div className={styles.checkbox__inputTick}>
        <TickCheckboxIcon />
      </div>
    </label>
  )
}
export default CheckboxGroupInput
